import * as React from "react";
import { connect } from "react-redux";
import { IdTooltipAdjust } from "../../constants/IdTooltipAdjust";
import { IdStyles } from "../../less/IdStyles";
import { selectResourceData } from "../../selectors/selectResourceInfo";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { ResourceIcon } from "../generic/icon/ResourceIcon";
import { NumberFormat } from "../generic/number-format/NumberFormat";
export var _RankingPlacementLeagueResources = function (_a) {
    var rewards = _a.rewards, selectResource = _a.selectResource;
    var renderedResources = [];
    var className = "ranking-placement-league";
    rewards.forEach(function (reward, index) {
        var resource = selectResource(reward.resourceId);
        // first element in array does not need to prepend a plus icon.
        if (index !== 0) {
            renderedResources.push(React.createElement("div", { className: className + "__reward-plus-item flex flex--guts", key: "plus-" + index },
                React.createElement(Icon, { icon: IdIcon.PlusIcnStroke, styleId: IdStyles.IconSmall })));
        }
        renderedResources.push(React.createElement("div", { className: className + "__reward-icon-item flex flex--guts", key: "icon-" + index },
            React.createElement(ResourceIcon, { resource: resource, styleId: IdStyles.IconSmall, tooltipVerticalAdjust: -IdTooltipAdjust.Large })), React.createElement("div", { className: className + "__reward-number-item flex flex--guts", key: "reward-number-" + index },
            React.createElement(NumberFormat, { className: IdStyles.TextBoldSecondaryOutline, amount: reward.amount })));
    });
    return React.createElement("div", { className: "flex flex--end w100" }, renderedResources);
};
var mapState = function (state) { return ({
    selectResource: function (resourceId) { return selectResourceData(state, resourceId); },
}); };
export var RankingPlacementLeagueResources = connect(mapState)(_RankingPlacementLeagueResources);



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/RankingPlacementLeagueResources.tsx
// module id = 2803
// module chunks = 3